// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface ICustomerNameType {
    id: number;
    customerCategoryType: any;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class CustomerNameType implements ICustomerNameType, IBaseType {
    public id: number;
    public customerCategoryType: any;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Legal Name CustomerNameType
	**/
    get LegalName(): ICustomerNameType {
        return this.FromId(2);
    }
    /**
		Returns Organization Name CustomerNameType
	**/
    get OrganizationName(): ICustomerNameType {
        return this.FromId(3);
    }
    /**
		Returns AKA CustomerNameType
	**/
    get AKA(): ICustomerNameType {
        return this.FromId(7);
    }
    /**
		Returns DBA CustomerNameType
	**/
    get DBA(): ICustomerNameType {
        return this.FromId(6);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('2', { id: 2, customerCategoryType: 1, value: 'LegalName', displayValue: 'Legal Name', description: 'Legal Name', sortOrder: 1, active: true });
        this._dictionary.add('3', { id: 3, customerCategoryType: 2, value: 'OrganizationName', displayValue: 'Organization Name', description: 'Organization Name', sortOrder: 2, active: true });
        this._dictionary.add('7', { id: 7, customerCategoryType: 3, value: 'AKA', displayValue: 'AKA', description: 'AKA', sortOrder: 3, active: true });
        this._dictionary.add('6', { id: 6, customerCategoryType: 2, value: 'DBA', displayValue: 'DBA', description: 'DBA', sortOrder: 4, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): ICustomerNameType {
        return this._dictionary[id];
    }

    public FromValue(value: string): ICustomerNameType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): ICustomerNameType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): ICustomerNameType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): ICustomerNameType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
